module.exports = __webpack_public_path__ + "img/bauges2020-1.43037c71.jpeg";